<template lang="pug">
  #sessions-layout
    RouterView(:key="$route.fullPath")
    LegalLinks
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {
    LegalLinks: require('@/components/LegalLinks').default,
  },
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
